export const THREE_MINUTES = 3 * 60 * 1000; // 3 minutes in milliseconds`
